module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG894172f6449fc8b04155bf0a17efac53.894172f6.png";